if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this._productHandlersBound = false;
    }

    connectedCallback() {
      this.performRecommendations();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const parsedDocument = new DOMParser().parseFromString(text, 'text/html');
          const area = this.dataset.recommendationArea;
          const sourceRecommendations =
            parsedDocument.querySelector(`product-recommendations[data-recommendation-area="${area}"] [data-recommendations]`) ||
            parsedDocument.querySelector('product-recommendations [data-recommendations]');

          if (!sourceRecommendations || !sourceRecommendations.children.length) return;

          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
          }
          recommendations.replaceChildren(...Array.from(sourceRecommendations.children).map((node) => node.cloneNode(true)));
          if (this.dataset.recommendationArea === 'product-grid') {
            this.initProductCards();
          } else {
            this.initSlider();
          }

          // initiate quick cart after fetch
          // to activate trigger button events
          setTimeout(() => {
            if (document.querySelector("quick-cart-drawer")) {
              document.querySelector("quick-cart-drawer").init();
            } else {
              // if quick-cart-drawer does not exists, remove trigger buttons
              this.querySelectorAll(".quick-cart-drawer__trigger").forEach(el => {
                el?.remove();
              })
            }
          }, 500);

        });
    }

    initProductCards() {
      this.initCardSliders();
      this.bindProductCardHandlers();
      if (typeof initCollectionSection === 'function') {
        var sectionEl = this.closest('[id^="shopify-section-"]');
        if (sectionEl) initCollectionSection(sectionEl);
      }
    }

    initCardSliders() {
      const sliderMedias = this.querySelectorAll('.product-card__media--slider:not([data-slider-init])');
      sliderMedias.forEach((media) => {
        media.setAttribute('data-slider-init', '1');
        const imgs = Array.from(media.querySelectorAll('.slider-img'));
        if (imgs.length <= 1) return;

        const swiperEl = document.createElement('div');
        swiperEl.className = 'swiper product-card-swiper';

        const wrapper = document.createElement('div');
        wrapper.className = 'swiper-wrapper';

        imgs.forEach((img) => {
          img.classList.remove('slider-img', 'slider-img--active');
          const slide = document.createElement('div');
          slide.className = 'swiper-slide';
          slide.appendChild(img);
          wrapper.appendChild(slide);
        });

        const btnPrev = document.createElement('div');
        btnPrev.className = 'swiper-button-prev';
        const btnNext = document.createElement('div');
        btnNext.className = 'swiper-button-next';

        const pagination = document.createElement('div');
        pagination.className = 'swiper-pagination';
        pagination.style.setProperty('--product-card-pagination-total', imgs.length);
        pagination.style.setProperty('--product-card-pagination-index', 0);

        swiperEl.appendChild(wrapper);
        swiperEl.appendChild(btnPrev);
        swiperEl.appendChild(btnNext);
        swiperEl.appendChild(pagination);

        media.innerHTML = '';
        media.appendChild(swiperEl);

        const cardSwiper = new Swiper(swiperEl, {
          loop: true,
          navigation: {
            prevEl: btnPrev,
            nextEl: btnNext,
          },
          pagination: {
            el: pagination,
            type: 'bullets',
            bulletClass: 'product-card-swiper__pagination-item',
            bulletActiveClass: 'product-card-swiper__pagination-item--active',
            renderBullet: function (index, className) {
              return '<span class="' + className + '"></span>';
            },
          },
        });

        cardSwiper.on('slideChange', function () {
          pagination.style.setProperty('--product-card-pagination-index', cardSwiper.realIndex);
        });
      });
    }

    bindProductCardHandlers() {
      if (this._productHandlersBound) return;
      this._productHandlersBound = true;

      this.addEventListener('click', (e) => {
        const pill = e.target.closest('.product-card__size-pill');
        if (!pill) return;
        e.stopPropagation();
        e.preventDefault();

        const sizesDiv = pill.closest('.product-card__sizes-hover');
        if (!sizesDiv) return;
        if (e.__productCardSizeAddHandled) return;
        if (pill.classList.contains('loading')) return;
        e.__productCardSizeAddHandled = true;
        const sizeOptionPos = parseInt(sizesDiv.dataset.sizeOptionPos, 10);
        const sizeValue = pill.dataset.value;

        const card = pill.closest('product-card');
        if (!card) return;

        const colorFieldset = card.querySelector('.js-color-fieldset');
        let selectedColor = null;
        let colorOptionPos = null;
        if (colorFieldset) {
          colorOptionPos = parseInt(colorFieldset.dataset.optionPos, 10);
          const checkedRadio = colorFieldset.querySelector('.variant-option-radio-input:checked');
          if (checkedRadio) selectedColor = checkedRadio.value;
        }

        const variantsScript = card.querySelector('[data-product-variants-json]');
        if (!variantsScript) return;

        let variants;
        try {
          variants = JSON.parse(variantsScript.textContent);
        } catch (err) {
          return;
        }

        const targetVariant = variants.find((v) => {
          if (v['option' + sizeOptionPos] !== sizeValue) return false;
          if (selectedColor && colorOptionPos) return v['option' + colorOptionPos] === selectedColor;
          return true;
        });

        if (!targetVariant || !targetVariant.available) {
          pill.classList.add('unavailable');
          setTimeout(() => pill.classList.remove('unavailable'), 1500);
          return;
        }

        sizesDiv.querySelectorAll('.product-card__size-pill').forEach((s) => s.classList.remove('selected', 'added'));
        pill.classList.add('selected', 'loading');
        window.LolaCartPopupInteraction?.lock();

        const cartPayload = { id: targetVariant.id, quantity: 1 };
        const popupImage = card.dataset.popupImage || '';
        if (popupImage) cartPayload.properties = { _popup_image: popupImage };

        window.LolaCartGift.request((window.routes?.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(cartPayload),
        })
          .then((r) => r.json())
          .then((data) => {
            pill.classList.remove('loading');
            if (data.id) {
              pill.classList.add('added');
              const cartPopupEl = document.querySelector('cart-popup');
              if (cartPopupEl) {
                if (popupImage) data.properties = Object.assign({}, data.properties, { _popup_image: popupImage });
                cartPopupEl.show(data);
              } else {
                window.location.href = window.routes.cart_url;
              }
              updateCartCounters();
              setTimeout(() => pill.classList.remove('added'), 2000);
            } else {
              window.LolaCartPopupInteraction?.unlock();
              window.LolaCartError?.show(data);
            }
          })
          .catch(() => {
            window.LolaCartPopupInteraction?.unlock();
            window.LolaCartError?.show();
            pill.classList.remove('loading');
          });
      });

      this.addEventListener('click', (e) => {
        if (window.innerWidth > 1023) return;
        const more = e.target.closest('.product-card__variants--more');
        if (!more) return;
        e.stopPropagation();
        e.preventDefault();
        const fieldset = more.closest('.js-color-fieldset');
        if (fieldset) fieldset.classList.toggle('color-option-expanded');
      }, true);

      this.addEventListener('change', (e) => {
        if (window.innerWidth > 1023) return;
        if (!e.target.matches('.variant-option-radio-input')) return;

        const fieldset = e.target.closest('.js-color-fieldset.color-option-expanded');
        if (!fieldset) return;

        const selectedDiv = e.target.closest('.button--variant');
        if (selectedDiv && selectedDiv.classList.contains('color-swatch-extra')) {
          const visibleDiv = fieldset.querySelector('.button--variant:not(.color-swatch-extra)');
          if (visibleDiv) visibleDiv.classList.add('small-hide', 'medium-hide', 'color-swatch-extra');
          selectedDiv.classList.remove('small-hide', 'medium-hide', 'color-swatch-extra');
        }

        fieldset.classList.remove('color-option-expanded');
      });

      document.addEventListener('click', (e) => {
        if (window.innerWidth > 1023) return;
        if (e.target.closest('.color-option-expanded')) return;

        this.querySelectorAll('.color-option-expanded').forEach((el) => {
          el.classList.remove('color-option-expanded');
        });
      });
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
